import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "80vh", display: "flex", alignItems: "center", backgroundColor: "#1a1a1a" }}>
      <Container maxWidth="xs">
        <Paper sx={{ p: 4, backgroundColor: "#2a2a2a", border: "1px solid #444" }}>
          <Typography variant="h5" sx={{ color: "#f0f0f0", mb: 3, textAlign: "center", fontWeight: 700 }}>
            Panel administracyjny
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Nazwa użytkownika"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{ mb: 2 }}
              InputProps={{ sx: { color: "#f0f0f0" } }}
              InputLabelProps={{ sx: { color: "#aaa" } }}
            />
            <TextField
              fullWidth
              type="password"
              label="Hasło"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
              InputProps={{ sx: { color: "#f0f0f0" } }}
              InputLabelProps={{ sx: { color: "#aaa" } }}
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#125ea8" },
                py: 1.5,
              }}
            >
              {loading ? "Logowanie..." : "Zaloguj się"}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
